module.exports = __webpack_public_path__ + "img/CB4E88_F99AD6_F384C3_ED75B9-256px.71919029.png";